import { API } from "src/api/request";

// Ажил үйлчилгээ
export async function getRiskReferenceType() {
  const response = await API().get("/risk/reference/type");
  return response.data;
}
export async function getRiskReferenceTypeId(id) {
  const response = await API().get("/risk/reference/type/" + id);
  return response.data;
}
export async function postRiskReferenceType(json) {
  const response = await API().post("/risk/reference/type", { ...json });
  return response.data;
}
export async function deleteRiskReferenceType(id) {
  const response = await API().delete("/risk/reference/type/" + id);
  return response.data;
}
export async function putRiskReferenceType(id, json) {
  const response = await API().put("/risk/reference/type/" + id, { ...json });
  return response;
}

// Аюулын хүчин зүйл
export async function getRiskFactor() {
  const response = await API().get("/risk/reference/threat");
  return response.data;
}

export async function getThreatType() {
  const response = await API().get("/risk/reference/threat/type");
  return response.data;
}
export async function postReferenceThreat(pid, json) {
  const response = await API().post("/risk/reference/threat/" + pid, {
    ...json,
  });
  return response.data;
}
export async function getReferenceThreat() {
  const response = await API().get("/risk/reference/threat");
  return response.data;
}
export async function putReferenceThreat(id, json) {
  const response = await API().put("/risk/reference/threat/" + id, { ...json });
  return response.data;
}
export async function deleteReferenceThreat(id) {
  const response = await API().delete("/risk/reference/threat/" + id);
  return response.data;
}
export async function postReferenceThreatType(json) {
  const response = await API().post("/risk/reference/threat/type", { ...json });
  return response.data;
}
export async function putReferenceThreatType(id, json) {
  const response = await API().put("/risk/reference/threat/type/" + id, {
    ...json,
  });
  return response.data;
}
export async function deleteReferenceThreatType(id) {
  const response = await API().delete("/risk/reference/threat/type/" + id);
  return response.data;
}
export async function getReferenceOperation() {
  const response = await API().get("/risk/reference/operation");
  return response.data;
}

// Эрсдлийн матриц
export async function getMatrixProb() {
  const response = await API().get("risk/matrix/probabilities");
  return response.data;
}
export async function getMatrixConseq() {
  const response = await API().get("risk/matrix/consequences");
  return response.data;
}
export async function getMatrix() {
  const response = await API().get("/risk/matrix");
  return response.data;
}

export async function getMatrixEqui(consequence_id, probability_id) {
  const response = await API().get(
    "/risk/matrix/" + consequence_id + "/" + probability_id
  );
  return response.data;
}

export async function patchReferenceOperationMatrix(id, json) {
  const response = await API().patch("/risk/reference/operation/" + id, {
    ...json,
  });
  return response.data;
}

// Нийтлэг ажил үйлчилгээ
export async function postReferenceOperation(json) {
  const response = await API().post("/risk/reference/operation", { ...json });
  return response.data;
}
export async function getReferenceOperationType(id) {
  const response = await API().get("/risk/reference/operation/" + id);
  return response.data;
}
export async function putReferenceOperation(id, json) {
  const response = await API().put("/risk/reference/operation/" + id, {
    ...json,
  });
  return response.data;
}
export async function deleteReferenceOperation(id) {
  const response = await API().delete("/risk/reference/operation/" + id);
  return response.data;
}
export async function getReferenceMeasure() {
  const response = await API().get("/risk/reference/measure");
  return response.data;
}

export async function getReferenceOperationMeasure(id, measure_id) {
  const response = await API().get(
    "risk/reference/operation/" + id + "/measure/" + measure_id
  );
  return response.data;
}

export async function postReferenceOperationMeasure(operation_id, json) {
  const response = await API().post(
    "risk/reference/operation/" + operation_id + "/measure",
    {
      ...json,
    }
  );
  return response.data;
}

export async function putReferenceOperationMeasure(
  operation_id,
  measure_id,
  json
) {
  const response = await API().put(
    "risk/reference/operation/" + operation_id + "/measure/" + measure_id,
    {
      ...json,
    }
  );
  return response.data;
}
export async function deleteReferenceOperationMeasure(
  operation_id,
  measure_id
) {
  const response = await API().delete(
    "/risk/reference/operation/" + operation_id + "/measure/" + measure_id
  );
  return response.data;
}

// Хянах самбар
export async function getDashboard(start, end) {
  const response = await API().get("/risk/assessment/dashboard", {
    params: { start, end },
  });
  return response.data;
}
